module.exports = __webpack_public_path__ + "static/img/login_bg.10257294.png";